// 監視対象の親要素（書き換えが発生する領域）を指定
const targetNode = document.querySelector(".com-contents"); 

// 監視オプション（子要素の変更を検知）
const config = { childList: true, subtree: true };

// 変更を監視し、テキストを再度書き換える関数
const callback = (mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === "childList" || mutation.type === "characterData") {
document.querySelectorAll(".com-value-title").forEach(element => {
  if (element.textContent.trim() === "Battery") {
    element.textContent = "バッテリー";
  } else if (element.textContent.trim() === "Motor") {
    element.textContent = "モーター";
  } else if (element.textContent.trim() === "Display") {
    element.textContent = "ディスプレイ";
  } else if (element.textContent.trim() === "Brake calipers") {
    element.textContent = "ブレーキ キャリパー";
  } else if (element.textContent.trim() === "Rotors") {
    element.textContent = "ローター";
  } else if (element.textContent.trim() === "Disk brake") {
    element.textContent = "ディスクブレーキ";
  } else if (element.textContent.trim() === "Handlebar") {
    element.textContent = "ハンドルバー";
  } else if (element.textContent.trim() === "Grips") {
    element.textContent = "グリップ";
  } else if (element.textContent.trim() === "Seatpost") {
    element.textContent = "シートポスト";
  } else if (element.textContent.trim() === "Saddle") {
    element.textContent = "サドル";
  } else if (element.textContent.trim() === "Bottom bracket") {
    element.textContent = "ボトム ブラケット";
  } else if (element.textContent.trim() === "Shifter") {
    element.textContent = "シフター";
  } else if (element.textContent.trim() === "Derailleur") {
    element.textContent = "ディレイラー";
  } else if (element.textContent.trim() === "Crankset") {
    element.textContent = "クランクセット";
  } else if (element.textContent.trim() === "Freewheel") {
    element.textContent = "フリーホイール";
  } else if (element.textContent.trim() === "Chain") {
    element.textContent = "チェーン";
  } else if (element.textContent.trim() === "Tire size") {
    element.textContent = "タイヤ サイズ";
  } else if (element.textContent.trim() === "Frame") {
    element.textContent = "フレーム";
  } else if (element.textContent.trim() === "Front suspension") {
    element.textContent = "フロント サスペンション";
  } else if (element.textContent.trim() === "Rear suspension") {
    element.textContent = "リア サスペンション";
  } else if (element.textContent.trim() === "Weight") {
    element.textContent = "車体重量";
  } else if (element.textContent.trim() === "battery weight") {
    element.textContent = "バッテリー重量";
  } else if (element.textContent.trim() === "Rider weight max") {
    element.textContent = "最大積載重量";
  }
});
}
});
};

// MutationObserver を作成
const observer = new MutationObserver(callback);

// 監視開始
observer.observe(targetNode, config);